// extracted by mini-css-extract-plugin
module.exports = {"move":"styles-module__move___1DVN4"};